import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import React from "react";
import { TileProps } from "../../../services/core/types";
import { userRendererStyles } from "./useRendererStyles";

export const ErrorTile: React.FC<TileProps> = ({ tile }) => {
  const classes = userRendererStyles();

  return (
    <Grid item xs={12} md={4}>
      <Card className={classes.root}>
        <CardHeader
          title={
            <Typography variant="body1" className={classes.cardHeading}>
              {tile.title}
            </Typography>
          }
          className={classes.header}
        />
        <Divider />
        <CardContent>
          <Grid container>
            <Typography variant="body1">{getMessageText(tile.type)}</Typography>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

const getMessageText = (tileType: string) => {
  switch (tileType) {
    case "Ofqual.ListTile":
    case "Ofqual.CaseListTile":
      return "No data to display";
    default:
      return "Failed to retrieve data";
  }
};
